import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { DataTransferService } from './services/datatransfer.service';
import { GlobalConstants } from './services/global-variables';
import { environment } from 'src/environments/environment';
import { BrowserStorageService } from './services/browser-storage.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'offers-app-au';
  public assetsPath = './../assets'
  private reloadSubScription: Subscription = {} as Subscription;
  public accordionItems = [];
  constructor(
    protected GlobalConstants: GlobalConstants,
    private _dts: DataTransferService,
    public meta: Meta,
    public pageTitle: Title,
    private browserStore: BrowserStorageService,
  ){
    this.reloadSubScription = this._dts.sharedReloadEvent.subscribe((resp: any) => {
      // console.log(resp);
      if(resp){
        this.browserStore.set('skipReloadLogout', 'true', 'session');
        location.reload();
      }
    });
    this.pageTitle.setTitle(this.GlobalConstants.data.titles.homepage_pagetitle);
    this.meta.addTags([
      { name: 'description', content: this.GlobalConstants.data.titles.homepage_description },
      { name: 'keywords', content: this.GlobalConstants.data.titles.homepage_keywords }
    ]);
    this.addScript(environment.analytics);
    this.deregisterServiceWorker();
  }
  reloadInit(){

  }
  ngOnDestroy(){
    if(this.reloadSubScription){
      this.reloadSubScription.unsubscribe();
    }
  }
  addScript(linkurl:string) {
    var headID = document.getElementsByTagName('head')[0];
    var link = document.createElement('script');
    link.src = linkurl;
    link.async = true;
    headID.appendChild(link);
  }
  private deregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          console.log('registrations to unregister', registrations)
          for (const registration of registrations) {
            registration.unregister()
          }
        })
        .catch(function (err) {
          console.log('Service Worker registration failed: ', err)
        })
    }
  }
}
